import { put, takeLatest, delay } from "redux-saga/effects"
import axios from "axios"
import * as Sentry from "@sentry/browser"

import { REQUEST } from "./constants"
import { receive } from "./actions"

const saga = "containers/CitySearchInput/saga"

export default function* root() {
  try {
    yield takeLatest(REQUEST, handleRequest)
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, { extra: { error, saga } })
  }
}

export function* handleRequest({ payload, payload: { field, values } }) {
  try {
    yield delay(100)
    const { data, status } = yield axios({
      method: "post",
      url: `/api/fetch/city`,
      data: {
        country: values.country,
        zip: `${values.zip}`
      },
      withCredentials: true,
      validateStatus: status => status === 200
    })
    yield put(
      receive({ field, result: data.map(d => ({ ...d, zip: String(d.zip) })) })
    )
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, {
      extra: { saga, payload }
    })
    yield put(receive({ field, error }))
  }
}
